export enum POLLUTION_ACTION_TYPES {
    GET_POLLUTION_DATA_START = 'pollution/GET_POLLUTION_DATA_START',
    GET_POLLUTION_DATA_SUCCESS = 'pollution/GET_POLLUTION_DATA_SUCCESS',
    GET_POLLUTION_DATA_FAILED = 'pollution/GET_POLLUTION_DATA_FAILED',
};